import { Route } from "react-router-dom";
import { IonContent, IonPage, IonRouterOutlet, isPlatform } from "@ionic/react";

import Login from "./Login";
import Register from "./Register";
import RegisterCloudbeds from "./RegisterCloudbeds";
import ForgotPassword from "./Forgot";
import ResetPassword from "./Reset";
import RegisterUser from "./RegisterUser";

import AuthLayout from "./layout";

const HOCAuth = () => {
  return (
    <IonRouterOutlet>
      <Route
        path="/auth"
        render={({ match }) => (
          <AuthLayout>
            <Route path={`${match.url}/login`} component={Login} />
            <Route path={`${match.url}/register`} component={Register} />
            <Route
              path={`${match.url}/register-onboarding`}
              component={Register}
            />

            <Route
              path={`${match.url}/register-cloudbeds`}
              component={RegisterCloudbeds}
            />
            <Route
              path={`${match.url}/forgot-password`}
              component={ForgotPassword}
            />
            <Route
              path={`${match.url}/reset-password`}
              component={ResetPassword}
            />
            <Route
              path={`${match.url}/register-user`}
              component={RegisterUser}
            />
          </AuthLayout>
        )}
      />
    </IonRouterOutlet>
  );
};

export default HOCAuth;
